<template>
    <div class="white elevation-6 error-card">
        <div class="error-header">
            <img :src="require('@/assets/errors/404.png')" width="192px" class="error-image">
        </div>
        <v-container class="pt-8 px-12 pb-12 d-flex flex-column grey--text text--darken-3 text-center">
            <div class="display-2">404</div>
            <div class="subtitle-1 mt-4">
                Ops! Não encontramos o que era para encontrar aqui. Por favor, tente novamente.
            </div>
            <div class="fluid d-flex justify-center">
                <v-btn
                    color="#fdd835"
                    class="grey-blue--text text--darken-3 button-primary elevation-2 mt-6"
                    @click="$router.go(-1)"
                >
                Voltar
                </v-btn>
            </div>
        </v-container>
        <div class="error-border-bottom"></div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>